import axios from 'axios'
import queryString from 'query-string'

import config from '../../config.client.js'

const url = config.apiUrl

export default {
  getUnit: uuid => {
    return axios.get(url + `units/${uuid}`)
  },
  getAllUnits: (organisationId, page) => {
    const query = { page }

    return axios.get(url + `organisations/${organisationId}/units?${queryString.stringify(query)}`)
  },

  createUnit: (organisationId, { name, description }) => {
    return axios.post(url + `organisations/${organisationId}/units`, { name, description })
  },

  editUnit: (organisationId, uuid, { name, description }) => {
    return axios.patch(url + `organisations/${organisationId}/units/${uuid}`, { name, description })
  },

  deleteUnit: (organisationId, uuid) => {
    return axios.delete(url + `organisations/${organisationId}/units/${uuid}`)
  },

  removeWopi360TargetFromUnit: (unitUuid, targetUuid) => {
    return axios.delete(url + `units/${unitUuid}/targets/${targetUuid}`)
  },

  updateUnitWopi360TargetRelations: (unitUuid, targetUuids) => {
    return axios.put(url + `units/${unitUuid}/targets`, { targetUuids })
  }
}



// WEBPACK FOOTER //
// ./src/services/unit.js